import(/* webpackMode: "eager" */ "/var/www/html/Ariel/src/app/blog/page.tsx");
